import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AuthService } from "./AuthService";

export const LoginCustomer = createAsyncThunk(
  "ls/LoginCustomer",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AuthService.auth().Login(payload);
      // console.log({ response });

      // if (response?.data?.data?.userType !== "Aggregator") {
      //   toast.error("You are not authorized to login here");
      // } else {
      //   localStorage.setItem(
      //     "user_profile",
      //     JSON.stringify(response?.data?.data, null, 2)
      //   );
      //   localStorage.setItem(
      //     "onboardingStatus",
      //     JSON.stringify(response?.data?.data?.onboardingStatus, null, 2)
      //   );
      //   setTimeout(() => {
      //     return window.location.replace("/user");
      //   }, 1);
      //   toast.success(response?.message);
      // }

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return error?.data;
    }
  }
);

export const AccountDetails = createAsyncThunk(
  "ls/AccountDetails",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AuthService.auth().AccountDetails(payload);
      localStorage.setItem(
        "user",
        JSON.stringify(response?.data?.responseModel)
      );
      // toast.success(response?.message);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.message);
      return error?.response;
    }
  }
);

// CustomerAccounts
export const CustomerAccounts = createAsyncThunk(
  "ls/CustomerAccounts",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AuthService.auth().CustomerAccounts(payload);
      localStorage.setItem(
        "user",
        JSON.stringify(response?.data?.responseModel)
      );
      // toast.success(response?.message);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.message);
      return error?.response;
    }
  }
);

// ***********************************************************************************************************************************************

export const ResetCustomerPassword = createAsyncThunk(
  "ls/LoginCustomer",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AuthService.auth().ResetPassword(payload);
      toast.success(response?.message);
      return response?.data;
    } catch (error) {
      //  exitReponse(error);
      return error?.response;
    }
  }
);

export const CurrentUser = createAsyncThunk(
  "ls/CurrentUser",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AuthService.auth().CurrentUser(payload);
      // localStorage.setItem(
      //   "user",
      //   JSON.stringify(response?.data?.responseModel)
      // );
      localStorage.setItem(
        "user_profile",
        JSON.stringify(response?.data?.data, null, 2)
      );
      localStorage.setItem(
        "onboardingStatus",
        JSON.stringify(response?.data?.data?.onboardingStatus, null, 2)
      );
      // toast.success(response?.message);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.message);
      return error?.response;
    }
  }
);

// LinenTransaction
export const LinenTransaction = createAsyncThunk(
  "ls/LinenTransaction",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AuthService.auth().LinenTransaction(payload);
      // localStorage.setItem(
      //   "user",
      //   JSON.stringify(response?.data?.responseModel)
      // );
      toast.success(response?.message);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.message);
      return error?.response;
    }
  }
);

export const ServiceReportToday = createAsyncThunk(
  "ls/ServiceReportToday",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AuthService.auth().ServiceToday(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.message);
      return error?.response;
    }
  }
);

export const ServiceReportWeek = createAsyncThunk(
  "ls/ServiceReportWeek",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AuthService.auth().ServiceWeek(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.message);
      return error?.response;
    }
  }
);

export const AgentDetails = createAsyncThunk(
  "ls/CurrentUser",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AuthService.auth().AgentDetails(payload);
      toast.success(response?.message);
      return response?.data;
    } catch (error) {
      //  exitReponse(error);
      return error?.response;
    }
  }
);

// // Customer/states
// CustomerStates: function (data) {
//   return api.get("customer/states");
// },

// // Customer/lga/1
// CustomerLga: function (data) {
//   return api.get(`customer/lga/${data}`);
// },

export const CustomerStates = createAsyncThunk(
  "ls/CustomerStates",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AuthService.auth().CustomerStates(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.message);
      return error?.response;
    }
  }
);

export const CustomerLga = createAsyncThunk(
  "ls/CustomerLga",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AuthService.auth().CustomerLga(payload);
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.message);
      return error?.response;
    }
  }
);

export const AuthSlice = createSlice({
  name: "Auth",
  initialState: "",
  extraReducers: {
    // ***********************************************************************************************************************************************

    [AccountDetails.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [AccountDetails.fulfilled]: (state, action) => {
      return { ...state, AccountDetails: action.payload, loading: false };
    },
    [AccountDetails.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [CustomerAccounts.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [CustomerAccounts.fulfilled]: (state, action) => {
      return { ...state, CustomerAccounts: action.payload, loading: false };
    },
    [CustomerAccounts.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    // ***********************************************************************************************************************************************
    [AgentDetails.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [AgentDetails.fulfilled]: (state, action) => {
      return { ...state, AgentDetails: action.payload, loading: false };
    },
    [AgentDetails.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [LoginCustomer.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [LoginCustomer.fulfilled]: (state, action) => {
      return { ...state, login: action.payload, loading: false };
    },
    [LoginCustomer.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [CurrentUser.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [CurrentUser.fulfilled]: (state, action) => {
      return { ...state, user: action.payload, loading: false };
    },
    [CurrentUser.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [LinenTransaction.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [LinenTransaction.fulfilled]: (state, action) => {
      return { ...state, LinenTransaction: action.payload, loading: false };
    },
    [LinenTransaction.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ServiceReportToday.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [ServiceReportToday.fulfilled]: (state, action) => {
      return { ...state, service_report_today: action.payload, loading: false };
    },
    [ServiceReportToday.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ServiceReportWeek.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [ServiceReportWeek.fulfilled]: (state, action) => {
      return { ...state, service_report_week: action.payload, loading: false };
    },
    [ServiceReportWeek.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    // [AgentDetails.pending]: (state) => {
    //   return {
    //     ...state,
    //     loading: true,
    //   };
    // },
    // [AgentDetails.fulfilled]: (state, action) => {
    //   return { ...state, deatails: action.payload, loading: false };
    // },
    // [AgentDetails.rejected]: (state, action) => {
    //   return {
    //     ...state,
    //     loading: false,
    //     error: action.payload,
    //   };
    // },

    [CustomerStates.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [CustomerStates.fulfilled]: (state, action) => {
      return { ...state, customer_states: action.payload, loading: false };
    },
    [CustomerStates.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [CustomerLga.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [CustomerLga.fulfilled]: (state, action) => {
      return { ...state, customer_lga: action.payload, loading: false };
    },
    [CustomerLga.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
  },
});

export default AuthSlice.reducer;
